import { Organization } from '@/types/organization';
import {
  Container,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
} from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOrg } from './useOrg';
import { useUserOrganizations } from './useOrganizations';

export default function SelectOrganizationPage() {
  const { selectedOrg, setSelectedOrg } = useOrg();
  const { data, isLoading } = useUserOrganizations();
  const navigate = useNavigate();
  const location = useLocation();

  const orgs = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  useEffect(() => {
    if (!isLoading && !selectedOrg && orgs.length === 1) {
      setSelectedOrg(orgs[0]);
      navigate((location.state as any)?.from || '/', { replace: true });
    }
  }, [isLoading, selectedOrg, orgs, setSelectedOrg, navigate, location.state]);

  if (isLoading) return <p>Loading...</p>;

  if (orgs.length === 0) {
    return (
      <Container maxWidth='sm'>
        <Paper sx={{ p: 4, mt: 4 }}>
          <Typography>No organizations available.</Typography>
        </Paper>
      </Container>
    );
  }

  const handleSelect = (org: Organization) => {
    setSelectedOrg(org);
    navigate((location.state as any)?.from || '/');
  };

  if (orgs.length === 1) {
    // effect will handle selection
    return null;
  }

  return (
    <Container maxWidth='sm'>
      <Paper sx={{ p: 4, mt: 4 }}>
        <Typography variant='h5' gutterBottom>
          Please select an organization
        </Typography>
        <List>
          {orgs.map((org) => (
            <ListItem key={org.id} disablePadding>
              <ListItemButton onClick={() => handleSelect(org)}>
                {org.name}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
}
